var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"event-service-name"},[_vm._v(" "+_vm._s(_vm.serviceName)),_c('br'),_c('span',{staticClass:"event-service-name-sep"}),_vm._v(_vm._s(_vm.serviceMenuName)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }